import * as THREE from "three";


export class DeviceAvatar {

    constructor(store) {
        this.store = store;
        this.DEVICE_IMAGES = {
            "Laptop": "laptop.png",
            "Monitor": "monitor.png",
            "Helyi nyomtató(usb)": "printer.png",
            "Hálózati nyomtató": "printer.png",
            "Dokkoló": "dock.png",
            "Sim kártya": "sim.png",
            "Mobiltelefon": "mobile.png"
        };
        this.SPECIAL_IMAGES = {
            "__OTHER_DEVICES__": "others.png",
            "__PLUS__": "plus.png",
            "__CITIES__": "pin.png",
            "__SET__": "set.png"
        };
        this.radius = null;
        this.wrapper = null;
        this.avatarcircle = null;
        this.img = null
        this.store.deviceAvatar = this;
    }

    render(imageUrl) {
        this.deviceItems = [];
        this.createWrapper();
        this.createAvatar(imageUrl);
        this.createItems();
        return this.wrapper;
    }

    createWrapper() {
        this.wrapper = document.createElement("div");
        this.wrapper.id = "avatarwrapper";
    }

    createAvatar(imageUrl) {
        this.avatarcircle = document.createElement("div");
        this.avatarcircle.className="avatarcircle-large";
        this.img=document.createElement("img");
        this.img.src=imageUrl;
        this.img.id="avatarpicture-large";
        this.avatarcircle.appendChild(this.img);
        this.wrapper.appendChild(this.avatarcircle);
    }

    createItems() {
        this.store.level.itDevices.forEach((device,index)=>{
            const item=this.createItem(device,index);
            this.wrapper.appendChild(item);
        });
    }

    createItem(device, index) {
        const item = document.createElement("div");
        item.className = "avataritem";
        const img = document.createElement("img");
        img.src = `/assets/${this.SPECIAL_IMAGES[device.category] ?? this.DEVICE_IMAGES[device.category] ?? "default.png"}`;
        img.className = "avataritem-image";
        const text = document.createElement("div");
        text.className = this.store.config.isSmall ? "font-10" : "font-15";
        text.textContent = device.barcode;
        item.appendChild(img);
        item.appendChild(text);
        this.bindItemEvents(item, device, index);
        this.deviceItems.push({element: item, angle: (index / this.store.level.itDevices.length) * Math.PI * 2});
        return item;
    }
    
    bindItemEvents(item, device, index) {
        
        item.addEventListener("mouseenter", () => {item.classList.add("avataritem-hover");});
        item.addEventListener("mouseleave", () => {item.classList.remove("avataritem-hover");
            // Ha ez a kijelölt elem, maradjon nagy
            if (item === this.selectedDeviceItem) {item.classList.add("avataritem-selected");}
        });
        item.addEventListener("click", e => {
            e.stopPropagation();
            // Előző kijelölés törlése
            if (this.selectedDeviceItem) {this.selectedDeviceItem.classList.remove("avataritem-selected");}

            // Új kijelölés
            this.selectedDeviceItem = item;
            item.classList.add("avataritem-selected");
            // Forgatás
            this.rotateToDevice(index);
            // Modal frissítése a cities/plus a modalba, a többi a detailsbe
            if(device.category === '__CITIES__' || device.category === '__PLUS__'){this.store.modalController.setLayout({layout: "MODALOPEN", component: device.category, data: device});
            }else{
                //AZ INVENTORYFORM NÉZI
                this.store.level.formType = 'IT'
                this.store.modalController.setLayout({layout: "MODALOPENWITHDETAILS", component: device.category, data: device});
            }
            
            // Újraméretezés a modal animáció után
            requestAnimationFrame(() => {requestAnimationFrame(() => {this.layout();});});
        });
    }

    updateAvatarSize() {
        if (!this.wrapper || !this.avatarcircle) return;
        const size = this.store.config.isSmall ? Math.min(this.wrapper.clientWidth, this.wrapper.clientHeight) * 0.3 : Math.min(this.wrapper.clientWidth, this.wrapper.clientHeight) * 0.4;
        this.avatarcircle.style.width = `${size}px`;
        this.avatarcircle.style.height = `${size}px`;
    }

    updateItemSizes() {
        const size = this.store.config.isSmall ? "2rem" : "5rem";
        this.deviceItems.forEach(device => {
            const img = device.element.querySelector("img");
            img.style.width = size;
            img.style.height = size;
        });
    }

    updatePositions() {
        this.deviceItems.forEach(device => {
            const x = Math.cos(device.angle) * this.radius;
            const y = Math.sin(device.angle) * this.radius;
            device.element.style.left = `calc(50% + ${x}px)`;
            device.element.style.top = `calc(50% + ${y}px)`;
        });
    }

    rotateToDevice(index) {
        const targetAngle = -Math.PI / 2;
        const currentAngle = this.deviceItems[index].angle;
        let delta = targetAngle - currentAngle;
        while (delta > Math.PI) delta -= Math.PI * 2;
        while (delta < -Math.PI) delta += Math.PI * 2;
        this.rotationAnimation = {
            start: performance.now(),
            duration: 600,
            from: 0,
            to: delta
        };
    }

    rotate() {
        if (!this.rotationAnimation) return;
        const a = this.rotationAnimation;
        const t = Math.min((performance.now() - a.start) / a.duration, 1);
        const rotation = THREE.MathUtils.lerp(a.from, a.to, t);
        this.deviceItems.forEach(device => {
        const angle = device.angle + rotation;
        const x = Math.cos(angle) * this.radius;
        const y = Math.sin(angle) * this.radius;
        device.element.style.left = `calc(50% + ${x}px)`;
        device.element.style.top = `calc(50% + ${y}px)`;
        });

        if (t === 1) {
            this.deviceItems.forEach(device => {device.angle += a.to;});
            this.rotationAnimation = null;
        }
        if (this.selectedDeviceItem) {this.selectedDeviceItem.classList.add("avataritem-selected");}
    }

    getRadius() {
        const rect = this.store.modalController.modalContent.getBoundingClientRect();
        return Math.min(rect.width, rect.height) * this.store.modalController.currentLayout.avatarScale;
    }

    layout() {
        if (!this.wrapper || !this.avatarcircle) return;
        this.updateAvatarSize();
        this.radius = this.getRadius();
        this.updateAvatarSize();
        this.updateItemSizes();
        this.updatePositions();
    }

    update() {
        if (!this.wrapper) return;
        if (this.rotationAnimation) {this.rotate();}
    }
}